import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Switch,Router } from 'react-router'
import { Route,useLocation } from 'react-router-dom'
import history from './dependencies/history'
import configureStore from './store/configureStore'
import bootstrap from 'bootstrap'
import PublicIndex from './components/pages/public/PublicIndex'
import HomePageNew from './components/pages/HomePageNew'
import HowItWorksNew from './components/pages/HowItWorksNew'
import PricingMoreNew from './components/pages/PricingMoreNew'
import HelpPageNew from './components/pages/HelpPageNew'
import PartnersPageNew from './components/pages/PartnersPageNew'
import TeamPageNew from './components/pages/TeamPageNew'
import SolTalentManage from './components/pages/SolTalentManage'
import TechPowered from './components/pages/TechPowered'
import SolUniv from './components/pages/SolUniv'
import SolTalentAcqui from './components/pages/SolTalentAcqui'
import SolGraduate from './components/pages/SolGraduate'
import FrequentlyAskedQuestionsNew from './components/pages/FrequentlyAskedQuestionNew'
import TermOfServicesNew from './components/pages/TermOfServicesNew'
import PrivacyPolicyNew from './components/pages/PrivacyPolicyNew'
import UserRegisterWizardFormContainerNew from './components/pages/UserRegisterWizardFormContainerNew'
import UserRegisterWizardFormContainerNew2 from './components/pages/UserRegisterWizardFormContainerNew2'
import TalkExpert from './components/pages/TalkExpert'

import TechVideo from './components/pages/TechVideo'
import TechAssess from './components/pages/TechAssess'
import TechHolistic from './components/pages/TechHolistic'
import TechStructured from './components/pages/TechStructured'
import TechJob from './components/pages/TechJob'
import Hourly from './components/pages/Hourly'
import Technical from './components/pages/Technical'
import TechNextgen from './components/pages/TechNextgen'
import InternalMobility from './components/pages/InternalMobility'
import TalentMapping from './components/pages/TalentMapping'
import SuccessionPlanning from './components/pages/SuccessionPlanning'
import HighPotential from './components/pages/HighPotential'
import EnterCodePage from './components/pages/EnterCodePage'

import PageNotFound from './components/pages/PageNotFound'

import 'font-awesome/css/font-awesome.css'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import 'nprogress/nprogress.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import 'rc-time-picker/assets/index.css'

import './styles/css/reset.css'
import './styles/css/all.min.css'
import './styles/css/astronaut.main-1.0.scss'
import './styles/sass/style.scss'

import * as serviceWorker from './serviceWorker';

import CandidateSupport from './components/pages/CandidateSupport'
import Feature from './components/pages/Feature'
import Learn from './components/pages/Learn'
import LearnDetail from './components/pages/LearnDetail'
import DemonstrationPage from './components/pages/DemonstrationPage'
import TrainingPage from './components/pages/TrainingPage'

import { Helmet,HelmetProvider  } from "react-helmet-async";

import metaTags from "./metadata";
import TaNgac from './components/pages/TaNgac'
import TaRpo from './components/pages/TaRpo'
import TaPro from './components/pages/TaPro'
import TaGrad from './components/pages/TaGrad'
import AIInterview from './components/pages/AIInterview'
import SkillValidation from './components/pages/SkillValidation'
import taApis from './components/pages/apis'
import UniAdmission from './components/pages/UniAdmission'
import UniCareer from './components/pages/UniCareer'
import LearnSearch from './components/pages/LearnSearch'
import AssessmentIndex from './components/pages/assessments/AssessmentIndex'
import AssessmentDetail from './components/pages/assessments/AssessmentDetail'



if (process.env.REACT_APP_API_HOST) {
    console.log = () => {};
    console.error = () => {};
    console.debug = () => {};
  }

export const store = configureStore();
const publicIndexTarget = document.getElementById("root")


const Meta = () => {
    const location = useLocation();
    const { title, description } = metaTags[location.pathname] || {};
  
    return (
      <Helmet>
        {title && <title>{title}</title>}
        <link rel="canonical" href={`${window.location.origin}${location.pathname}`} />
        {description && <meta name="description" content={description} />}
        <meta name="robots" content="index, follow" />
        
      </Helmet>
    );
  };

ReactDOM.render(
    <HelmetProvider >
        <Provider store={store}>
            <Router history={history}>
            <Meta />
                <PublicIndex >
                <Switch>
            
                    <Route exact path='/' component={HomePageNew} />
                    <Route exact path='/about' component={TeamPageNew} />
                    <Route exact path='/partners' component={PartnersPageNew} />
                    <Route exact path='/how-it-works' component={HowItWorksNew} />
                    <Route exact path='/features' component={PricingMoreNew} />
                    <Route exact path='/help' component={HelpPageNew} />
                    <Route exact path='/faq' component={FrequentlyAskedQuestionsNew} />
                    <Route exact path='/faq/:langId' component={FrequentlyAskedQuestionsNew} />
                    <Route exact path='/termsofservice' component={TermOfServicesNew} />
                    <Route exact path='/privacypolicy' component={PrivacyPolicyNew} />
                    <Route exact path='/solution/nextgen-assessment-center-astrnt' component={SolTalentManage} />
                    <Route exact path='/solution/university-admissi-astrnt' component={SolUniv} />
                    <Route exact path='/solution/structured-hiring-astrnt' component={SolTalentAcqui} />
                    <Route exact path='/solution/graduate-hiring' component={SolGraduate} />
                    <Route exact path='/register' component={UserRegisterWizardFormContainerNew} />
                    <Route exact path='/talk-to-an-expert' component={TalkExpert} />
                    <Route exact path='/registered' component={UserRegisterWizardFormContainerNew2} />
                    <Route exact path='/enter-code' component={EnterCodePage} />
                    <Route exact path='/candidate-support' component={CandidateSupport} />
                    <Route exact path='/features' component={Feature} />
                    <Route exact path='/learn' component={Learn} />
                    <Route exact path='/learn-detail/:postId' component={LearnDetail} />
                    <Route exact path='/learn-search' component={LearnSearch} />
                    <Route exact path='/request-demo' component={DemonstrationPage} />
                    <Route exact path='/training' component={TrainingPage} />
                    <Route exact path='/tech/video-interviewing' component={TechVideo} />
                    <Route exact path='/tech/assessments' component={TechAssess} />
                    <Route exact path='/tech/holistic-assessments' component={TechHolistic} />
                    <Route exact path='/tech/structured-interview-builder' component={TechStructured} />
                    <Route exact path='/tech/job-simulations' component={TechJob} />
                    <Route exact path='/tech/nextgen-assessment-center' component={TechNextgen} />
                    <Route exact path='/tech/powered-by-astrnt' component={TechPowered} />
                    <Route exact path='/qr1' component={() => {
                        window.location.href = 'https://astrnt.co/solution/structured-hiring-astrnt';
                        return null;
                    }}/>
                    <Route exact path='/qr2' component={() => {
                        window.location.href = 'https://astrnt.co/solution/nextgen-assessment-center-astrnt';
                        return null;
                    }}/>
                    <Route exact path='/professional' component={TaPro} />
                    <Route exact path='/graduate' component={TaGrad} />
                    <Route exact path='/nextgen-assessment-center' component={TaNgac} />
                    <Route exact path='/nextgen-rpo' component={TaRpo} />
                    <Route exact path='/talent-acquisition/professional' component={TaPro} />
                    <Route exact path='/talent-acquisition/technical' component={Technical} />
                    <Route exact path='/talent-acquisition/hourly' component={Hourly} />                                        
                    <Route exact path='/talent-acquisition/graduate' component={TaGrad} />
                    <Route exact path='/talent-acquisition/astrnt-platform/ai-structured-video-interview' component={AIInterview} />                    
                    <Route exact path='/talent-acquisition/skill-validation' component={SkillValidation} />                    
                    <Route exact path='/apis' component={taApis} />                                        
                    <Route exact path='/admissions' component={UniAdmission} />                                        
                    <Route exact path='/career-center' component={UniCareer} />                                        
                    <Route exact path='/talent-management/internal-mobility' component={InternalMobility} />                                        
                    <Route exact path='/talent-management/talent-mapping' component={TalentMapping} />                                        
                    <Route exact path='/talent-management/succession-planning' component={SuccessionPlanning} />                                        
                    <Route exact path='/talent-management/high-potential-identification' component={HighPotential} />
                    <Route exact path='/assessments-and-interviews' component={AssessmentIndex} />                                        
                    <Route exact path='/assessments-and-interviews/:assessmentId' component={AssessmentDetail} />                                        
                    <Route component={PageNotFound} />
                </Switch>
                </PublicIndex>
            </Router>
        </Provider>
        </HelmetProvider>,
publicIndexTarget
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

/**
 * AccessLog keys:
 * 
 * button_register | Start Your Free Plan
 * button_talk_to_an_expert
 * button_learn_more
 * button_view_all_stories
 * button_register_for_demo
 * button_explore_assessment_interview
 * button_get_a_demo
 * 
 */